export default __webpack_public_path__ + "static/14-28c83e584aecd4ebe40f56b040917f3e.jpg";